import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NSErrorModule, NSGridModule } from '@norfolk-southern/accessns-components';

import { EBillDisputeComponent } from '@ruby/modules/ebill/submodules/ebill-dispute/components/ebill-dispute.component';
import { EBillDisputeActionsContainer } from '@ruby/modules/ebill/submodules/ebill-dispute/containers/cells/ebill-dispute-actions.container';
import { EBillDisputeColumnHeaderContainer } from '@ruby/modules/ebill/submodules/ebill-dispute/containers/cells/ebill-dispute-column-header.container';
import { EBillDisputeContainer } from '@ruby/modules/ebill/submodules/ebill-dispute/containers/ebill-dispute.container';
import { EBillDisputeRoutingModule } from '@ruby/modules/ebill/submodules/ebill-dispute/ebill-dispute-routing.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [
    EBillDisputeComponent,
    EBillDisputeContainer,
    EBillDisputeActionsContainer,
    EBillDisputeColumnHeaderContainer
  ],
  imports: [
    CommonModule,
    NSGridModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    EBillDisputeRoutingModule,
    MatInputModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    NSErrorModule,
    DirectivesModule
  ],
  exports: [EBillDisputeContainer]
})
export class EBillDisputeModule {}
